import { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * This hook checks url for the hash and tries to scroll to the elemnt with the same id as the hash.
 * Should be included only once per page.
 */
function useScrollToAnchor() {
  const location = useLocation()
  const lastHash = useRef('')
  const maxAttempts = 5

  useEffect(() => {
    // Don't run if there's no hash
    if (!location.hash) {
      return
    }

    lastHash.current = location.hash.slice(1)

    let attempts = 0

    const intervalId = setInterval(() => {
      const element = document.getElementById(lastHash.current)
      if (element || attempts >= maxAttempts) {
        clearInterval(intervalId)
        element?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      attempts++
    }, 300) // Check every 300ms

    return () => clearInterval(intervalId) // Cleanup on unmount or if location changes
  }, [location])

  return null
}

export default useScrollToAnchor
